import $ from "jquery";
import "./assets/scss/_bofi.scss";

import ComponentLibrary from "./auto-register-components";
import * as Utils from "./utils";
import * as Api from "./api";
import * as Includes from "./includes";

export default ComponentLibrary;
export { Utils, Api, Includes };

// Modals
$(document).ready(function() {
  $("body").on("click", ".c-modal__trigger", function(e) {
    e.preventDefault();
    var target = $(this).data("target");
    $("html").addClass("show-modal");
    $("#" + target).addClass("active");
  });
  $("body").on("click", ".c-modal__close", function() {
    $(this)
      .parents(".c-modal.active")
      .removeClass("active");
    $("html").removeClass("show-modal");
  });
});

// Mobile menu
$(document).ready(function() {
  // Inclusive navigation
  var navButton = document.querySelector("nav button");
  var header = document.querySelector("header");

  navButton.addEventListener("click", function() {
    let expanded = this.getAttribute("aria-expanded") === "true" || false;
    this.setAttribute("aria-expanded", !expanded);
    let menu = this.nextElementSibling;
    menu.hidden = !menu.hidden;

    var viewportWidth = $(window).width();

    if (!menu.hidden && viewportWidth <= 900) {
      header.classList.add("is-active");
    } else {
      header.classList.remove("is-active");
    }
  });
});
